/** Shared lazy-load helper for marketing landings (IntersectionObserver). */
export function initLazyImages(root: ParentNode = document): () => void {
  const images = root.querySelectorAll<HTMLImageElement>(
    'img.lazyload[data-src]',
  );
  if (images.length === 0) {
    return () => undefined;
  }

  if (!('IntersectionObserver' in window)) {
    images.forEach((img) => {
      const dataSrc = img.getAttribute('data-src');
      if (dataSrc && !img.getAttribute('src')) {
        img.setAttribute('src', dataSrc.startsWith('/') ? dataSrc : `/${dataSrc}`);
      }
    });
    return () => undefined;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        const img = entry.target as HTMLImageElement;
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc && !img.getAttribute('src')) {
          img.setAttribute(
            'src',
            dataSrc.startsWith('/') ? dataSrc : `/${dataSrc}`,
          );
        }
        observer.unobserve(img);
      });
    },
    { rootMargin: '200px 0px' },
  );

  images.forEach((img) => observer.observe(img));
  return () => observer.disconnect();
}

export function playGifById(gifId: string) {
  const gif = document.getElementById(gifId);
  if (!gif) {
    return;
  }
  const dataSrc = gif.getAttribute('data-src');
  if (dataSrc) {
    gif.setAttribute('src', dataSrc);
  }
}
